import type { Trading } from '../../types';

export const tradingConfig: Trading = {
    alwaysRenderVolumeTypes: false,
    applyDateTimeForValidUntilDate: false,
    applyIdAsQueryParam: false,
    applyOnlyOtcOrSofaForValidUntil: false,
    applyOrderTypeModal: false,
    applyOrderTypeTooltip: false,
    applySimpleSellForMarket: false,
    applySimpleSwitchForMarket: false,
    applyValidFromForSell: false,
    buyOrderExpectedFeeTypes: ['MAX_FEE'],
    defaultAmountPrecision: 2,
    defaultLimitPrecision: 8,
    expectedOrderValueFromSignInfo: false,
    loadBidAskPriceFromQuotes: false,
    marketTradingConditionsUrl: '',
    noTimeDateFormat: false,
    orderSignEquivalentValueAttribute: 'equivalentAmount',
    orderTypesWithStaticWarning: [],
    sellOrderExpectedFeeTypes: ['MAX_FEE'],
    settlementAccountCountryId: false,
    shouldLoadTradingDocuments: false,
    shouldPrefillOrderTypeLimit: false,
    showAdvisorCode: false,
    showAllMarketPlaces: false,
    showLastPriceForSwitch: false,
    showMinimumVolumePriceForSwitch: false,
    showOrderTypeInfo: false,
    showRiskDisclosureWarning: false,
    showSettingsLinksInFees: false,
    showTargetPortfolio: false,
    showVenueForSwitch: false,
    switchOrderExpectedFeeTypes: ['MAX_FEE'],
    tradingValidationStrategies: {
        accountTradeableStatus: false,
        accountNotAllowedToTradeFlag: false,
        accountTradingActivationAllowed: false,
        profileSecuritiesTradingAllowedFlag: false,
    },
    validUntilBasedOnLimitType: false,
    allowRegularBuyOrders: true,
    redirectRegularBuyToStore: false,
    includeIsinInQuestionnaireUrl: false,
    version: 3,
    review: {
        url: '',
        investmentCenterUrl: '',
    },
};
